export const RECEIVED_MESSAGE = 'RECEIVED_BOT_MESSAGE';


export const receiver = (state = {messages: []}, action = {}) => {
    switch (action.type) {
        case RECEIVED_MESSAGE: {
            return {
                messages: state.messages.concat([action.message])
            }
        }
        default:
            return state
    }

};


// WEBPACK FOOTER //
// ./src/reducers/testreceive.js